module.exports = __webpack_public_path__ + "static/media/target_lv_2d85dfe1f7cd9c37ca0ff1d075aa36d3d.webp";